import {Pipe, PipeTransform} from "@angular/core";
import {SimUtilityService} from "@services";
@Pipe({
	name: "round",
	standalone: false,
})
export class RoundPipe implements PipeTransform {
	transform(value: number, args?: any) {
		return SimUtilityService.round(value, args);
	}
}
